import { Checkbox, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, SelectChangeEvent } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { AppContext } from '../../../app-context';
import { ALL } from '../../../features/common/constants';
import { get } from '../../../features/common/http.services';
import { isNotNull } from '../../../features/common/util.services';
import { IDropdownProps } from '../dropdown/i-dropdown.component';
import './i-multiselect.style.scss'
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 600,
            width: 250,
        },
    },
};

const IMultiSelect = (props: IDropdownProps) => {
    const appContext = useContext(AppContext);
    const [selectedItem, setSelectedItem] = useState<string[]>([]);
    const [itemList, setItemList] = useState<any[]>(props.itemList ? props.itemList : []);
    const { control, register, setValue } = useFormContext();
    const [loader, setLoader] = useState(false);
    const onChangeEvent = (event: SelectChangeEvent<typeof selectedItem>) => {
        const {
            target: { value },
        } = event;
        setValue(props.name, value);
        setSelectedItem(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        if (props.onChangeEvent) {
            props.onChangeEvent(event);
        }
    };

    useEffect(() => {
        if (isNotNull(props.url)) {
            // setLoader(true);
            get(props.url, appContext,
                (response: any) => {
                    updateItemList(response.data);
                    setLoader(false);
                }, (error: any) => {
                    console.log(error);
                    setLoader(false);
                    appContext.setErrorMessage(error.message);
                });
        }
    }, [props.url]);

    useEffect(() => {
        const list = props.itemList ? props.itemList : [];
        updateItemList(list);
    }, [props.itemList]);

    const updateItemList = (list: any[]) => {
        if (props.allItemRequired) {
            setItemList([ALL, ...list]);
        } else if (!props.required) {
            setItemList([' ', ...list]);
        } else {
            setItemList(list);
        }
    }

    return loader ? <></> : <Controller
        control={control}
        name={props.name}
        rules={{
            required: {
                value: props.required,
                message: "Required Field"
            },
            ...props.rules
        }}
        render={({ field, fieldState }) => (<FormControl className="i-dropdown" required={props.required}>
            <InputLabel variant="outlined" shrink={true} id={props.name}>{props.label}</InputLabel>
            <Select
                {...field}
                {...register(props.name)}
                id={props.name}
                size="small"
                onChange={onChangeEvent}
                labelId={props.name}
                disabled={props.disabled}
                label={props.label}
                value={field.value}
                input={<OutlinedInput  label={props.label} />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
                multiple
            >
                {itemList.map((item, idx) => (
                    <MenuItem key={item} value={item}>
                        <Checkbox checked={selectedItem.includes(item)} />
                        <ListItemText primary={item} />
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText error={isNotNull(fieldState.error)}>{fieldState.error ? fieldState.error.message : null}</FormHelperText>
        </FormControl>
        )}
    />
};

export default IMultiSelect;